import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Award, Sparkles } from "lucide-react";

export default function BadgesPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/badges").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const earned = data.all.filter((b) => b.earned);
  const locked = data.all.filter((b) => !b.earned);
  return (
    <div className="nb-card p-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-extrabold">Badges</h2>
          <p className="text-sm text-neutral-600">{earned.length} of {data.all.length} unlocked</p>
        </div>
        <span className="nb-badge nb-tag-sun"><Award className="w-3.5 h-3.5" /> {earned.length} earned</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
        {earned.concat(locked).map((b) => (
          <div
            key={b.id}
            data-testid={`badge-${b.id}`}
            className={`p-3 border-2 border-black rounded-xl text-center ${b.earned ? "bg-[var(--sun)]" : "bg-white opacity-50"}`}
            title={b.desc}
          >
            <div className="text-3xl">{b.emoji}</div>
            <div className="font-extrabold text-sm mt-1">{b.name}</div>
            <div className="text-[11px] text-neutral-600 leading-tight">{b.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
